// extracted by mini-css-extract-plugin
module.exports = {"sdsButton":"buttons_sdsButton__D7K92","primaryButtonAlt":"PrimaryAltButton_primaryButtonAlt__GVBKY buttons_sdsButton__D7K92"};